import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    personalNovedades: [],
    /* Info de paginación */
    paginaActual: 1,
    totalPaginas: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,
    /* Filtro */
    fechaDesde: moment(new Date()).add(-60, 'days').format('YYYY-MM-DD'),
    fechaHasta: moment(new Date()).format('YYYY-MM-DD'),
    personal: null,
    tipoFalta: null,
};

const mutations = {
    updateField,

    'INICIALIZAR_OPCIONES'(state) {
        state.personalNovedades = [];
        /* Opciones de filtro y paginacion */
        state.paginaActual = 1;
        state.registrosPorPagina = 10;
        state.totalRegistros = 0;
        state.totalPaginas = 0;

        state.fechaDesde = moment(new Date()).add(-30, 'days').format('YYYY-MM-DD');
        state.fechaHasta = moment(new Date()).format('YYYY-MM-DD');
        state.personal = null;
        state.tipoFalta = null;
    },

    'INICIALIZAR' (state) {
        state.personalNovedades = [];
    },
    'SET_PERSONAL_NOVEDADES' (state, personalNovedades) {
        state.personalNovedades = personalNovedades;
    },
    'SET_PAGINATION' (state, params) {
        state.paginaActual = params.paginaActual;
        state.totalPaginas = params.totalPaginas;
        state.registrosPorPagina = params.registrosPorPagina;
        state.totalRegistros = params.totalRegistros;
    },
};

const actions = {
    inicializarOpciones ( { commit } ) {
        commit('INICIALIZAR_OPCIONES');
    },
        
    getPersonalNovedades: ({commit}) => {
        return new Promise((resolve, reject) => {
            commit ('INICIALIZAR');

            var queryString = '?pageSize=' + state.registrosPorPagina
                + '&pageNumber=' + state.paginaActual
                + '&fechaDesde='+ moment(state.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta='+ moment(state.fechaHasta).format('YYYY-MM-DD');
          
            if (state.personal) {
                if (state.personal != null) {
                    if (state.personal.id != 0) {
                        queryString += '&personalId=' + state.personal.id;
                    }
                }
            }
    
            if (state.tipoNovedad) {
                if (state.tipoNovedad != null) {
                    if (state.tipoNovedad.id != 0) {
                        queryString += '&tipoNovedadId=' + state.tipoNovedad.id;
                    }
                }
            }

            apiAxios.get('personalnovedades' + queryString)
            .then(res => {
                if (res.headers.pagination){
                    const pagination= JSON.parse(res.headers.pagination)
                    var params= {
                        paginaActual: pagination.currentPage,
                        registrosPorPagina: pagination.itemsPerPage,
                        totalRegistros: pagination.totalItems,
                        totalPaginas: pagination.totalPages
                    }
                    commit ('SET_PAGINATION', params);
                }

                commit ('SET_PERSONAL_NOVEDADES', res.data);
                resolve();
            })
            .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
    delete ( {}, personalNovedadId ) {
        return new Promise((resolve, reject) => {
            apiAxios.post('personalnovedades/' + personalNovedadId + '/delete' ) 
                .then( () => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
};

const getters = {
    getField,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}